import React from 'react'
import {Flex} from '/app/src/component';
import Post from './Post';
import {FeedbackModel} from '/app/src/model';
import DateTime from '/app/src/lib/DateTime';
import Theme from '/app/src/theme';
import SVG from 'react-inlinesvg';
import style from './style.css'

class PostHistory extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            feedbackList: []
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {faqId} = this.props
        if (prevProps.faqId !== faqId) {
            FeedbackModel.readById('helpdesk', faqId, payload => this.setState({ feedbackList: payload.feedbacks}));
        }
    }

    componentDidMount() {
        const {faqId} = this.props;
        FeedbackModel.readById('helpdesk', faqId, payload => this.setState({ feedbackList: payload.feedbacks}));
    }

    render() {
        return (
            <Flex column w='100%'>
                <Flex className={style.Summary} h='100px' bg='grey1' w='100%' shrink={0}>
                    {this._renderSummary()}
                </Flex>
                <Flex w='100%'>
                    {this._renderFeedbackList()}
                </Flex>
            </Flex>
        )
    }

    _renderFeedbackList() {
        const {feedbackList} = this.state;
        const postCmps = [];
        for (let i = 0; i < feedbackList.length; i++) {
            const current = feedbackList[i];
            const date = current['date_created'].split('T')[0];
            postCmps.push(
                <Flex className={style.PostWrapper} key={i} grow>
                    <Post
                        text={current['feedback']}
                        date={DateTime.formatDate(date, 'yyyy-mm-dd')}
                        rating={current['rating']}
                        />
                </Flex>
            )
        }
        return (
            <Flex column h='100%' w='100%'>
                {postCmps}
            </Flex>
        )
    }

    _countFeedback() {
        const {feedbackList} = this.state
        const feedbackArray = { 'positive': 0, 'negative': 0 }
        for (let i = 0; i < feedbackList.length; i++) {
            const feedback = feedbackList[i];
            const rating = feedback['rating'];
            if (rating === 1) feedbackArray['positive']++;
            else if (rating === -1) feedbackArray['negative']++;
        }
        return feedbackArray
    }

    _renderSummary() {
        const feedbackCounts = this._countFeedback()
        return (
            <Flex center column w='100%'>
                <Flex color='black1' hAlignContent='center'>
                    Besökar-feedback
                </Flex>
                <Flex center marginTop='15px' h='30px'>
                    <Flex className={style.StatsText} center marginRight='15px'>
                        <SVG style={{'fill': Theme.colors.green1, width: '30px', height: '30px', marginRight: '5px'}}
                            src='/images/emojiSmile1.svg'/>
                        {feedbackCounts['positive']}
                    </Flex>
                    <Flex className={style.StatsText} center marginLeft='15px'>
                        <SVG style={{'fill': Theme.colors.red1, width: '30px', height: '30px', marginRight: '5px'}}
                            src='/images/emojiUnhappy.svg'/>
                        {feedbackCounts['negative']}
                    </Flex>
                </Flex>
            </Flex>
        )
    }
}

export default PostHistory;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/HelpDesk/RightPanel/PostHistory/index.js